import { BrowserRouter as Router } from 'react-router-dom';
import { Routes } from 'routes';
import SessionProvider from 'contexts/session';
import 'react-multi-email/style.css';
import LaunchDarklyProvider from 'contexts/launchDarkly';
import AppProvider from 'contexts/app';
import { CapabilitiesProvider } from 'contexts/capabilities';

const App = (): JSX.Element => {
  return (
    <AppProvider>
      <Router>
        <SessionProvider>
          <CapabilitiesProvider>
            <LaunchDarklyProvider>
              <Routes />
            </LaunchDarklyProvider>
          </CapabilitiesProvider>
        </SessionProvider>
      </Router>
    </AppProvider>
  );
};

export default App;
